import { Button } from "@mui/material";

const baseSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  padding: "8px 16px",
  borderRadius: "4px",
  textTransform: "none",
  fontSize: "1rem",
  backgroundColor: "var(--main-color)",
  fontWeight: 400,
  lineHeight: "1.5",
  height: "45px",
};

const neutralSx = {
  backgroundColor: "#f9fafb",
  borderColor: "#d0d5dd",
  padding: "6px 10px",
  gap: 0.7,
  fontSize: "0.85rem",
  color: "#344054",
  height: "35px",
  "&:hover": {
    backgroundColor: "#f2f4f7",
    borderColor: "#c6cad1",
  },
};

const CustomButton = ({
  children,
  sx = {},
  startIcon,
  endIcon,
  variant = "contained",
  neutral = false,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        ...baseSx,
        ...(neutral && variant === "outlined" ? neutralSx : {}),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
